import { VideoServiceType } from 'domains/models/calendar/videoServiceType';
import { z } from 'zod';

export enum CalendarUnavailableReasonType {
  Event = 1,
  Calendar = 2,
  Buffer = 3,
  Range = 4,
  Member = 5,
  Transparent = 6,
  Duration = 7,
  RestrictDay = 8,
  RestrictWeek = 9,
  RestrictMonth = 10,
  Resource = 11,
  Holiday = 12,
}
export enum CalendarSourceType {
  Jicoo = 1,
  Integration = 2,
}

export const CalendarUnavailableReasonTypeEnum = z.nativeEnum(
  CalendarUnavailableReasonType,
);
export const CalendarSourceTypeEnum = z.nativeEnum(CalendarSourceType);
export const VideoServiceTypeEnum = z.nativeEnum(VideoServiceType);
